import { render, staticRenderFns } from "./SensorIndex.vue?vue&type=template&id=51565a14"
import script from "./SensorIndex.vue?vue&type=script&lang=ts"
export * from "./SensorIndex.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports